import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Entry, Asset, EntryCollection } from 'contentful';
import { Router } from '@angular/router';
import { FileService } from '../file.service';
import { SharedDataService } from "../shared-data.service";
import { ApiOpenmindService } from '../apiopenmind.service';

export class TaskDTO {
  constructor(public src: string, public file: File) { }
}

@Component({
  selector: 'app-activity-detail',
  templateUrl: './activity-detail.component.html',
  styleUrls: ['./activity-detail.component.css']
})
export class ActivityDetailComponent implements OnInit {

  // define class properties
  public selectedModuleId: string;
  public selectedModule: Entry<any>;
  public selectedModuleAsset: EntryCollection<any>;
  public activities: Entry<any>[] = [];
  public activitiesAsset: EntryCollection<any>;
  public selectedFile: TaskDTO;
  public userId: string;
  public activitiesLoaded: any[] = [];
  public activitiesDone: boolean[] = [];

  constructor(private router: Router, private contentfulService: ContentfulService, private fileService: FileService, private sharedData: SharedDataService, private apiopenmind: ApiOpenmindService) {
    let user = JSON.parse(sessionStorage.getItem("loginData")).userResponse;
    this.userId = user.userid;
  }

  ngOnInit() {
    //this.sharedData.currentModule.subscribe(message => this.selectedModuleId = message)
    this.selectedModuleId = sessionStorage.getItem("moduleId");
    this.contentfulService.getActivitiesByModule(this.selectedModuleId).then(x => this.activities = x);
    this.apiopenmind.GetActivity(this.userId).toPromise().then(x => this.activitiesLoaded = x.moduleWork);
  }

  getStatus(activityId): boolean {
    if (this.activitiesLoaded == undefined) { return false; }
    let activity = this.activitiesLoaded.find(x => x.moduleId == activityId);
    if (activity == undefined) { return false; }
    else { return true }
  }
  
  processFile(imageInput: any, activityId: string, i :number) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    let session = JSON.parse(sessionStorage.getItem("loginData")).lSessionResponse[0];
    let sessionId = session.sessionid;//"1231233";
    let sessionName = session.sessionname;//"Bogotá - Enero 2018";
    let user = JSON.parse(sessionStorage.getItem("loginData")).userResponse;
    let userId = user.userid;
    let userName = user.username + " " + user.lastname;//"Juan Perez";
    let activityName = "Tarea1";
    let path = "PRÁCTICAS CAMPUS ACADEMY/" + sessionName + "/" + userName + "/activityName-" + file.name;

    reader.addEventListener('load', (event: any) => {
      this.selectedFile = new TaskDTO(event.target.result, file);
      this.fileService.uploadImage(this.selectedFile.file).subscribe(
        (res) => {
          const date = new Date();
          var formatedDate = date.getFullYear() + "" + ('0' + (date.getMonth() + 1)).slice(-2) + "" + ('0' + (date.getDate())).slice(-2);
          this.apiopenmind.AddModuleWork(new Number(formatedDate).valueOf(), path, activityId, sessionId, userId, function () { document.getElementById("resourceButton_" + i).setAttribute("src", "Campus/assets/images/uploadButton_Ready.png"); document.getElementById("resourceP_" + i).innerText ="¡YA HAS COMPLETADO ESTÁ ACTIVIDAD!" });
        },
        (err) => {
          alert("Ha sucedido un error, por favor intenta nuevamente");
          console.log(err);
        });
    });

    reader.readAsDataURL(file);
  }

}
